// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#w-dialogs-container.w-dialogs-container--with-backdrop{background:rgba(0,0,0,.15);height:100%;left:0;position:fixed;top:0;width:100%;z-index:var(--layer-5)}#w-dialogs-container:before{background:rgba(0,0,0,.3);content:\"\";height:100%;left:-9999px;opacity:0;position:fixed;top:0;visibility:hidden;width:100%}#w-dialogs-container.w-dialogs-container--with-backdrop:before{left:0;opacity:1;transition:opacity .2s ease-out;visibility:visible}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
